import { render } from "./zuhe.vue?vue&type=template&id=401531a8&scoped=true"
import script from "./zuhe.vue?vue&type=script&lang=js"
export * from "./zuhe.vue?vue&type=script&lang=js"

import "./zuhe.vue?vue&type=style&index=0&id=401531a8&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401531a8"]])

export default __exports__